import { Label, UIText1, Avatar, Link } from '@cian/ui-kit';
import { IconActionArrowRight16, IconToggleStarOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './style.css';
import { IDeveloperInfoRedesigned } from '../../../../../types/developerInfo';
import { numberToPrettyString } from '../../../../../utils/numberToPrettyString';
interface IDeveloperInfoProps {
  developerInfo: IDeveloperInfoRedesigned;
}

export const DeveloperInfo: React.FC<IDeveloperInfoProps> = ({ developerInfo }) => {
  const roomLinks = React.useMemo(() => {
    const { flatsStat } = developerInfo;

    if (!flatsStat) {
      return [];
    }

    const links: Array<{ label: string; count: string; url: string }> = [];

    if (flatsStat.total > 0) {
      links.push({
        label: 'Все',
        count: numberToPrettyString(flatsStat.total),
        url: flatsStat.url,
      });
    }

    flatsStat.flats.forEach(flat => {
      links.push({
        label: flat.roomCountText,
        count: numberToPrettyString(flat.count),
        url: flat.url,
      });
    });

    return links;
  }, [developerInfo]);

  return (
    <div className={style['container']} data-testid="DeveloperInfo">
      <div className={style['avatar']}>
        <Avatar src={developerInfo.logoUrl as string} size={80} type="builder" hideBorder />
      </div>

      <div className={style['text-block']}>
        <div className={style['title-row']}>
          <a className={style['title']} href={developerInfo.url} target="_blank" rel="noreferrer">
            {developerInfo.name}
          </a>
          <div className={style['labels']}>
            {developerInfo.rating && (
              <Label
                background="surface-inverted-default"
                color="decorative-orange"
                borderColor="accent-main-secondary"
                borderStyle="solid"
                borderWidth={1}
                icon={<IconToggleStarOn16 color="decorative-orange" />}
              >
                {developerInfo.rating}
              </Label>
            )}
            {developerInfo.reliabilityLabel && (
              <Label
                background="surface-inverted-default"
                color="text-main-default"
                borderColor="accent-main-secondary"
                borderStyle="solid"
                borderWidth={1}
              >
                {developerInfo.reliabilityLabel}
              </Label>
            )}
          </div>
        </div>

        <div className={style['info-row']}>
          {developerInfo.since && <UIText1 color="text-primary-default">{developerInfo.since}</UIText1>}

          <Link
            href={developerInfo.url}
            target="_blank"
            rel="noreferrer"
            fontSize="M"
            color="current_color"
            afterIcon={<IconActionArrowRight16 color="current_color" />}
          >
            Подробнее о застройщике
          </Link>

          {developerInfo.newobjectsStats &&
            developerInfo.newobjectsStats.map((stat, index) => (
              <Link
                key={index}
                href={stat.url as string}
                target="_blank"
                rel="noreferrer"
                fontSize="M"
                color="current_color"
                afterIcon={<IconActionArrowRight16 color="current_color" />}
              >
                {stat.name}
              </Link>
            ))}
        </div>

        {roomLinks.length > 0 && (
          <div className={style['room-links']}>
            {roomLinks.map(link => (
              <a key={link.label} href={link.url} className={style['room-link']}>
                <UIText1 color="current_color">{link.label}</UIText1>
                <UIText1 color="text-secondary-default">{link.count}</UIText1>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
